import { render, staticRenderFns } from "./SecondRule.vue?vue&type=template&id=56d64963&scoped=true"
import script from "./SecondRule.vue?vue&type=script&lang=js"
export * from "./SecondRule.vue?vue&type=script&lang=js"
import style0 from "./SecondRule.vue?vue&type=style&index=0&id=56d64963&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d64963",
  null
  
)

export default component.exports